export default __webpack_public_path__ + "static/media/endava.43d78212.png";